import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faTimes } from '@fortawesome/free-solid-svg-icons';
import ConfirmModal from '../../components/ConfirmModal';
import { useNavigate } from 'react-router-dom';
import contaService from '../../services/contaService';

const initialState = {
  codigo: '',
  descricao: '',
  tipo: 'Entrada',
  contabilizar: 'Não',
};

const ContaCreate = () => {
  const [form, setForm] = useState(initialState);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const navigate = useNavigate();

  const validate = async () => {
    if (!form.codigo.trim()) return 'O código é obrigatório.';
    if (!form.descricao.trim()) return 'A descrição é obrigatória.';
    if (!form.tipo.trim()) return 'O tipo é obrigatório.';
    
    // Verificar se código já existe
    try {
      const contas = await contaService.list({ codigo: form.codigo });
      if (contas.contas && contas.contas.length > 0) {
        return 'Já existe uma conta com este código.';
      }
    } catch (error) {
      console.error('Erro ao verificar código:', error);
    }
    
    // Verificar se descrição já existe
    try {
      const contas = await contaService.list({ descricao: form.descricao });
      if (contas.contas && contas.contas.length > 0) {
        return 'Já existe uma conta com esta descrição.';
      }
    } catch (error) {
      console.error('Erro ao verificar descrição:', error);
    }
    
    return '';
  };

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError('');
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    const validationError = await validate();
    if (validationError) {
      setError(validationError);
      setLoading(false);
      return;
    }
    setLoading(false);
    setShowConfirm(true);
  };

  const handleConfirm = async () => {
    setShowConfirm(false);
    setLoading(true);
    setError('');
    setSuccess(false);
    try {
      await contaService.create(form);
      setLoading(false);
      setSuccess(true);
      setTimeout(() => navigate('/contas'), 1200);
    } catch (err) {
      setLoading(false);
      setError('Erro ao cadastrar conta.');
    }
  };

  return (
    <div className="w-full bg-white rounded shadow p-6 mt-6">
      <h2 className="text-xl font-bold mb-4">Cadastrar Conta</h2>
      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <div>
          <label className="block text-sm font-medium mb-1">Código *</label>
          <input
            type="text"
            name="codigo"
            value={form.codigo}
            onChange={handleChange}
            maxLength={255}
            required
            className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-400"
            placeholder="Código da conta"
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium mb-1">Descrição *</label>
          <input
            type="text"
            name="descricao"
            value={form.descricao}
            onChange={handleChange}
            maxLength={255}
            required
            className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-400"
            placeholder="Descrição da conta"
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium mb-1">Tipo *</label>
          <select
            name="tipo"
            value={form.tipo}
            onChange={handleChange}
            required
            className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-400"
          >
            <option value="Entrada">Entrada</option>
            <option value="Saida">Saida</option>
          </select>
        </div>
        
        <div>
          <label className="block text-sm font-medium mb-1">Contabilizar *</label>
          <select
            name="contabilizar"
            value={form.contabilizar}
            onChange={handleChange}
            required
            className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-400"
          >
            <option value="Sim">Sim</option>
            <option value="Não">Não</option>
          </select>
        </div>
        
        {error && <div className="text-red-600 text-sm">{error}</div>}
        {loading && <div className="text-blue-600 text-sm">Salvando...</div>}
        {success && <div className="text-green-600 text-sm">Conta cadastrada com sucesso!</div>}
        
        <div className="flex flex-row gap-1 justify-end mt-2 w-full overflow-x-auto">
          <button type="button" className="p-2 sm:px-4 sm:py-2 rounded bg-gray-200 hover:bg-gray-300 text-gray-700 flex items-center gap-2 w-10 sm:w-auto justify-center" onClick={() => navigate('/contas')}>
            <FontAwesomeIcon icon={faTimes} />
            <span className="hidden sm:inline">Cancelar</span>
          </button>
          <button type="submit" className="p-2 sm:px-4 sm:py-2 rounded bg-green-600 text-white font-semibold hover:bg-green-700 flex items-center gap-2 w-10 sm:w-auto justify-center disabled:opacity-50" disabled={loading} aria-label="Salvar">
            <FontAwesomeIcon icon={faSave} />
            <span className="hidden sm:inline">Salvar</span>
          </button>
        </div>
      </form>
      <ConfirmModal
        isOpen={showConfirm}
        title="Confirmar Cadastro"
        message="Deseja realmente cadastrar esta conta?"
        onCancel={() => setShowConfirm(false)}
        onConfirm={handleConfirm}
      />
    </div>
  );
};

export default ContaCreate;
